module.exports = __webpack_public_path__ + "img/Frame_34.4c9f235a.png";